export const password = () => {
  /**
   * @param {string} val
   * @return {boolean}
   */
  const _isLength = val => {
    return val.length >= 10 && val.length <= 20
  }

  /**
   * @param {string} val
   * @return {boolean}
   */
  const _isAllowedCombination = val => {
    const matchCount =
      (val.match(/[0-9]+/) ? 1 : 0) +
      (val.match(/[a-z]+/) ? 1 : 0) +
      (val.match(/[A-Z]+/) ? 1 : 0) +
      (val.match(/[@./_\-?!%#$&*=~]+/) ? 1 : 0)
    if (matchCount < 3) {
      return false
    }
    return true
  }
  /**
   * @param {string} val
   * @return {boolean}
   */
  const _isDifferentChar = val => {
    return val.match(/(.).?((?!.*\1).).*((?!.*\2).).*((?!.*\3).)/) ? true : false
  }
  /**
   * @param {string} val
   * @return {boolean}
   */
  const _isAllowedChar = val => {
    return val.match(/^[0-9a-zA-Z@./_\-?!%#$&*=~]+$/) ? true : false
  }
  /**
   * @param {string} val
   * @return {boolean}
   */
  const _isNotConsecutive = val => {
    return val.match(/(.)\1{2,}/) ? false : true
  }

  return {
    _isLength: _isLength,
    _isAllowedCombination: _isAllowedCombination,
    _isDifferentChar: _isDifferentChar,
    _isAllowedChar: _isAllowedChar,
    _isNotConsecutive: _isNotConsecutive,
  }
}
